import React from 'react';

import { generatorSize } from '../../../constants';
import { defaultBackgroundColors } from './utils/defaults';

const Background = ({ primary, secondary, paths }) => {
  const {
    primary: defPrimary,
    secondary: defSecondary
  } = defaultBackgroundColors;

  const fills = {
    primary: primary || defPrimary,
    secondary: secondary || defSecondary
  }

  return (
    <g>
      <rect width={generatorSize} height={generatorSize} fill={fills.secondary} />
      {paths.map((wave, index) => (
        <path
          width={generatorSize}
          height={generatorSize * 0.75}
          key={wave}
          d={wave}
          fill={ index % 2 === 0 ? fills.primary : fills.secondary}
        />
      ))}
    </g>
  );
}

export default Background;
